import * as client_hooks from '../../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170'),
	() => import('./nodes/171'),
	() => import('./nodes/172'),
	() => import('./nodes/173'),
	() => import('./nodes/174'),
	() => import('./nodes/175'),
	() => import('./nodes/176'),
	() => import('./nodes/177'),
	() => import('./nodes/178'),
	() => import('./nodes/179'),
	() => import('./nodes/180'),
	() => import('./nodes/181'),
	() => import('./nodes/182'),
	() => import('./nodes/183'),
	() => import('./nodes/184'),
	() => import('./nodes/185'),
	() => import('./nodes/186'),
	() => import('./nodes/187'),
	() => import('./nodes/188'),
	() => import('./nodes/189'),
	() => import('./nodes/190'),
	() => import('./nodes/191'),
	() => import('./nodes/192'),
	() => import('./nodes/193'),
	() => import('./nodes/194'),
	() => import('./nodes/195'),
	() => import('./nodes/196'),
	() => import('./nodes/197'),
	() => import('./nodes/198'),
	() => import('./nodes/199'),
	() => import('./nodes/200'),
	() => import('./nodes/201'),
	() => import('./nodes/202'),
	() => import('./nodes/203'),
	() => import('./nodes/204'),
	() => import('./nodes/205'),
	() => import('./nodes/206'),
	() => import('./nodes/207'),
	() => import('./nodes/208'),
	() => import('./nodes/209'),
	() => import('./nodes/210'),
	() => import('./nodes/211'),
	() => import('./nodes/212'),
	() => import('./nodes/213'),
	() => import('./nodes/214'),
	() => import('./nodes/215'),
	() => import('./nodes/216'),
	() => import('./nodes/217'),
	() => import('./nodes/218'),
	() => import('./nodes/219'),
	() => import('./nodes/220'),
	() => import('./nodes/221'),
	() => import('./nodes/222'),
	() => import('./nodes/223'),
	() => import('./nodes/224'),
	() => import('./nodes/225'),
	() => import('./nodes/226'),
	() => import('./nodes/227'),
	() => import('./nodes/228'),
	() => import('./nodes/229'),
	() => import('./nodes/230'),
	() => import('./nodes/231'),
	() => import('./nodes/232'),
	() => import('./nodes/233'),
	() => import('./nodes/234'),
	() => import('./nodes/235'),
	() => import('./nodes/236'),
	() => import('./nodes/237'),
	() => import('./nodes/238'),
	() => import('./nodes/239'),
	() => import('./nodes/240')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [35,[2]],
		"/(customer)/account": [221,[29,30]],
		"/(customer)/account/communication": [222,[29,30]],
		"/(customer)/account/contact-preferences": [223,[29,30]],
		"/(customer)/autopay": [224,[29]],
		"/(customer)/autopay/setup": [226,[29]],
		"/(customer)/autopay/[autopayId]/edit": [225,[29]],
		"/(auth)/(login-flow)/changepassword": [213,[27,28]],
		"/(app)/clients": [36,[2]],
		"/(app)/clients/new": [95,[2]],
		"/(app)/clients/[id=integer]": [37,[2,3]],
		"/(app)/clients/[id=integer]/audit-history": [38,[2,3]],
		"/(app)/clients/[id=integer]/autopay-preview": [39,[2,3]],
		"/(app)/clients/[id=integer]/collections/assignments": [40,[2,3]],
		"/(app)/clients/[id=integer]/collections/compliance": [41,[2,3]],
		"/(app)/clients/[id=integer]/collections/dashboard": [42,[2,3]],
		"/(app)/clients/[id=integer]/collections/strategies": [43,[2,3]],
		"/(app)/clients/[id=integer]/collections/strategies/[strategyId]": [44,[2,4]],
		"/(app)/clients/[id=integer]/collections/strategies/[strategyId]/campaign": [45,[2,4]],
		"/(app)/clients/[id=integer]/collections/strategies/[strategyId]/dashboard": [46,[2,4]],
		"/(app)/clients/[id=integer]/collections/strategies/[strategyId]/queues": [47,[2,4]],
		"/(app)/clients/[id=integer]/collections/strategies/[strategyId]/waterfall-runs": [48,[2,4]],
		"/(app)/clients/[id=integer]/collections/strategies/[strategyId]/waterfall-runs/[runId=integer]": [49,[2,4]],
		"/(app)/clients/[id=integer]/collections/teams": [50,[2,3]],
		"/(app)/clients/[id=integer]/collections/teams/[teamId]": [51,[2,3]],
		"/(app)/clients/[id=integer]/collections/universe": [52,[2,3]],
		"/(app)/clients/[id=integer]/credit-reports": [53,[2,3]],
		"/(app)/clients/[id=integer]/datasources": [54,[2,3,5]],
		"/(app)/clients/[id=integer]/datasources/edit/[datasourceid=integer]": [55,[2,3,5]],
		"/(app)/clients/[id=integer]/datasources/new": [56,[2,3,5]],
		"/(app)/clients/[id=integer]/encryptionkeys": [57,[2,3,6]],
		"/(app)/clients/[id=integer]/encryptionkeys/edit/[encryptionkeyid=integer]": [58,[2,3,6]],
		"/(app)/clients/[id=integer]/encryptionkeys/new": [59,[2,3,6]],
		"/(app)/clients/[id=integer]/fields": [60,[2,3]],
		"/(app)/clients/[id=integer]/jobhistory": [61,[2,3]],
		"/(app)/clients/[id=integer]/jobhistory/[activityId=integer]": [62,[2,3]],
		"/(app)/clients/[id=integer]/lenderfields": [63,[2,3]],
		"/(app)/clients/[id=integer]/lenders": [64,[2,3]],
		"/(app)/clients/[id=integer]/lenders/new": [67,[2,3]],
		"/(app)/clients/[id=integer]/lenders/[lenderId=integer]/edit": [65,[2,3,7]],
		"/(app)/clients/[id=integer]/lenders/[lenderId=integer]/fields": [66,[2,3,7]],
		"/(app)/clients/[id=integer]/livejobs": [68,[2,3]],
		"/(app)/clients/[id=integer]/logs": [69,[2,3]],
		"/(app)/clients/[id=integer]/obligations": [70,[2,3]],
		"/(app)/clients/[id=integer]/obligors": [71,[2,3]],
		"/(app)/clients/[id=integer]/portal": [72,[2,3]],
		"/(app)/clients/[id=integer]/products": [73,[2,3]],
		"/(app)/clients/[id=integer]/products/new": [74,[2,3]],
		"/(app)/clients/[id=integer]/reports": [75,[2,3]],
		"/(app)/clients/[id=integer]/reports/[reportdefinitionid=integer]": [76,[2,3]],
		"/(app)/clients/[id=integer]/status": [77,[2,3]],
		"/(app)/clients/[id=integer]/status/edit/[[statusCode]]": [78,[2,3,8]],
		"/(app)/clients/[id=integer]/status/new": [79,[2,3]],
		"/(app)/clients/[id=integer]/treasury": [80,[2,3,9]],
		"/(app)/clients/[id=integer]/treasury/accounts": [81,[2,3,9]],
		"/(app)/clients/[id=integer]/treasury/accounts/new": [84,[2,3,9]],
		"/(app)/clients/[id=integer]/treasury/accounts/[lenderBankId=integer]": [82,[2,3,9]],
		"/(app)/clients/[id=integer]/treasury/accounts/[lenderBankId=integer]/balances": [83,[2,3,9]],
		"/(app)/clients/[id=integer]/treasury/balancing": [85,[2,3,9,10]],
		"/(app)/clients/[id=integer]/treasury/balancing/payments": [86,[2,3,9,10]],
		"/(app)/clients/[id=integer]/treasury/balancing/transfer": [87,[2,3,9,10,11]],
		"/(app)/clients/[id=integer]/treasury/payments": [88,[2,3,9]],
		"/(app)/clients/[id=integer]/treasury/summary-payments": [89,[2,3,9]],
		"/(app)/clients/[id=integer]/truebi": [90,[2,3]],
		"/(app)/clients/[id=integer]/users": [91,[2,3,12]],
		"/(app)/clients/[id=integer]/users/edit/[[userid=integer]]": [93,[2,3,12]],
		"/(app)/clients/[id=integer]/users/service-user": [94,[2,3,12]],
		"/(app)/clients/[id=integer]/users/[userid=integer]": [92,[2,3,12]],
		"/(app)/collections/work-queue": [96,[2]],
		"/(auth)/contact": [216,[27]],
		"/(app)/credit-reports": [97,[2]],
		"/external-redirect": [237,[33]],
		"/(app)/feature-flags": [98,[2]],
		"/(auth)/forgotpassword": [217,[27]],
		"/impersonate": [238],
		"/(app)/jobs": [99,[2]],
		"/(app)/livejobs": [100,[2]],
		"/(auth)/(login-flow)/login": [214,[27,28]],
		"/(auth)/logout": [218,[27]],
		"/(auth)/(login-flow)/mfa": [215,[27,28]],
		"/notices": [239,[34]],
		"/oauth/authorize": [240],
		"/(app)/obligations/[id=integer]": [101,[2,13]],
		"/(app)/obligations/[id=integer]/activities": [102,[2,13]],
		"/(app)/obligations/[id=integer]/adjustment": [103,[2,13]],
		"/(app)/obligations/[id=integer]/audit-history": [104,[2,13]],
		"/(app)/obligations/[id=integer]/communication": [105,[2,13]],
		"/(app)/obligations/[id=integer]/contacts": [106,[2,13]],
		"/(app)/obligations/[id=integer]/contacts/add": [112,[2,13]],
		"/(app)/obligations/[id=integer]/contacts/[obligorId=integer]/addresses": [107,[2,13,14]],
		"/(app)/obligations/[id=integer]/contacts/[obligorId=integer]/details": [108,[2,13,14]],
		"/(app)/obligations/[id=integer]/contacts/[obligorId=integer]/emailaddresses": [109,[2,13,14]],
		"/(app)/obligations/[id=integer]/contacts/[obligorId=integer]/notes": [110,[2,13,14]],
		"/(app)/obligations/[id=integer]/contacts/[obligorId=integer]/phonenumbers": [111,[2,13,14]],
		"/(app)/obligations/[id=integer]/credit-report-history": [113,[2,13]],
		"/(app)/obligations/[id=integer]/customerPortal": [114,[2,13]],
		"/(app)/obligations/[id=integer]/data": [115,[2,13]],
		"/(app)/obligations/[id=integer]/details": [116,[2,13]],
		"/(app)/obligations/[id=integer]/documents": [117,[2,13]],
		"/(app)/obligations/[id=integer]/documents/statements": [118,[2,13]],
		"/(app)/obligations/[id=integer]/journals/new": [122,[2,13]],
		"/(app)/obligations/[id=integer]/journals/[journalId=integer]": [119,[2,13,15]],
		"/(app)/obligations/[id=integer]/journals/[journalId=integer]/edit": [120,[2,13,15]],
		"/(app)/obligations/[id=integer]/journals/[journalId=integer]/view": [121,[2,13,15]],
		"/(app)/obligations/[id=integer]/ledgers/[ledger]": [123,[2,13]],
		"/(app)/obligations/[id=integer]/payments": [124,[2,13]],
		"/(app)/obligations/[id=integer]/payments/autopays": [127,[2,13]],
		"/(app)/obligations/[id=integer]/payments/autopays/new": [129,[2,13]],
		"/(app)/obligations/[id=integer]/payments/autopays/[autopayId=integer]": [128,[2,13,16]],
		"/(app)/obligations/[id=integer]/payments/methods": [130,[2,13]],
		"/(app)/obligations/[id=integer]/payments/other": [131,[2,13]],
		"/(app)/obligations/[id=integer]/payments/payment": [132,[2,13]],
		"/(app)/obligations/[id=integer]/payments/refund": [133,[2,13]],
		"/(app)/obligations/[id=integer]/payments/[paymentId=integer]/deposit-info": [125,[2,13]],
		"/(app)/obligations/[id=integer]/payments/[paymentId=integer]/reverse": [126,[2,13]],
		"/(app)/obligations/[id=integer]/related": [134,[2,13]],
		"/(app)/obligations/[id=integer]/transactions": [135,[2,13]],
		"/(app)/obligations/[id=integer]/transactions/new": [138,[2,13]],
		"/(app)/obligations/[id=integer]/transactions/print": [139,[2,13]],
		"/(app)/obligations/[id=integer]/transactions/[activityid=integer]/edit": [136,[2,13,17]],
		"/(app)/obligations/[id=integer]/transactions/[activityid=integer]/return": [137,[2,13,17]],
		"/(app)/obligations/[id=integer]/workflows": [140,[2,13]],
		"/(app)/obligors/[id=integer]": [141,[2,18]],
		"/(app)/obligors/[id=integer]/audit-history": [142,[2,18]],
		"/(app)/obligors/[id=integer]/bankruptcies": [143,[2,18]],
		"/(customer)/payments": [227,[29,31]],
		"/(customer)/payments/history": [228,[29,31]],
		"/(customer)/payments/methods": [229,[29,31]],
		"/(customer)/payments/methods/bank-account": [230,[29,31]],
		"/(customer)/payments/methods/credit-card-bare": [232],
		"/(customer)/payments/methods/credit-card": [231,[29,31]],
		"/(customer)/payments/new": [233,[29,31]],
		"/(open)/privacypolicy": [235,[32]],
		"/(app)/products/[id=integer]": [144,[2,19]],
		"/(app)/products/[id=integer]/assetfields": [145,[2,19]],
		"/(app)/products/[id=integer]/audit-history": [146,[2,19]],
		"/(app)/products/[id=integer]/configure": [147,[2,19]],
		"/(app)/products/[id=integer]/credit-reporting": [148,[2,19]],
		"/(app)/products/[id=integer]/dataexports": [149,[2,19]],
		"/(app)/products/[id=integer]/dataexports/[[exportid=integer]]/edit": [150,[2,19,20]],
		"/(app)/products/[id=integer]/dataexports/[exportid=integer]/history": [151,[2,19,21]],
		"/(app)/products/[id=integer]/dataexports/[exportid=integer]/history/[historyId=integer]/content": [152,[2,19,21]],
		"/(app)/products/[id=integer]/dataexports/[exportid=integer]/view": [153,[2,19]],
		"/(app)/products/[id=integer]/dataimports": [154,[2,19]],
		"/(app)/products/[id=integer]/dataimports/[[importId=integer]]/edit": [155,[2,19,22]],
		"/(app)/products/[id=integer]/dataimports/spread-exceptions": [159,[2,19]],
		"/(app)/products/[id=integer]/dataimports/[importId=integer]/history": [156,[2,19,23]],
		"/(app)/products/[id=integer]/dataimports/[importId=integer]/history/[historyId=integer]/records": [157,[2,19,23,24]],
		"/(app)/products/[id=integer]/dataimports/[importId=integer]/view": [158,[2,19]],
		"/(app)/products/[id=integer]/documents": [160,[2,19]],
		"/(app)/products/[id=integer]/documents/edit/[[documenttemplateid=integer]]": [161,[2,19]],
		"/(app)/products/[id=integer]/documents/pages": [162,[2,19]],
		"/(app)/products/[id=integer]/documents/pages/edit/[[pagetemplateid=integer]]": [163,[2,19]],
		"/(app)/products/[id=integer]/fees": [164,[2,19]],
		"/(app)/products/[id=integer]/fees/new": [166,[2,19]],
		"/(app)/products/[id=integer]/fees/[feeId=integer]/edit": [165,[2,19]],
		"/(app)/products/[id=integer]/fields": [167,[2,19]],
		"/(app)/products/[id=integer]/ledgers": [168,[2,19]],
		"/(app)/products/[id=integer]/ledgers/edit/[[ledgerCode]]": [169,[2,19]],
		"/(app)/products/[id=integer]/obligationfields": [170,[2,19]],
		"/(app)/products/[id=integer]/obligations/[[segmentKey]]": [171,[2,19]],
		"/(app)/products/[id=integer]/obligors/[[segmentKey]]": [172,[2,19]],
		"/(app)/products/[id=integer]/payment-spread": [173,[2,19]],
		"/(app)/products/[id=integer]/projectfields": [174,[2,19]],
		"/(app)/products/[id=integer]/projects": [175,[2,19]],
		"/(app)/products/[id=integer]/projects/new": [178,[2,19]],
		"/(app)/products/[id=integer]/projects/[projectId=integer]/edit": [176,[2,19]],
		"/(app)/products/[id=integer]/projects/[projectId=integer]/fields": [177,[2,19]],
		"/(app)/products/[id=integer]/returnreasons": [179,[2,19]],
		"/(app)/products/[id=integer]/returnreasons/new": [181,[2,19]],
		"/(app)/products/[id=integer]/returnreasons/[returnReasonId=integer]/edit": [180,[2,19]],
		"/(app)/products/[id=integer]/scripts": [182,[2,19]],
		"/(app)/products/[id=integer]/scripts/[[scriptid=integer]]/edit": [183,[2,19]],
		"/(app)/products/[id=integer]/scripts/payment/test": [187,[2,19]],
		"/(app)/products/[id=integer]/scripts/releases": [188,[2,19]],
		"/(app)/products/[id=integer]/scripts/releases/[releaseId=integer]": [189,[2,19]],
		"/(app)/products/[id=integer]/scripts/[scriptid=integer]": [184,[2,19,25]],
		"/(app)/products/[id=integer]/scripts/[scriptid=integer]/workflow-instances": [185,[2,19,25]],
		"/(app)/products/[id=integer]/scripts/[scriptid=integer]/workflow-instances/[instanceId=integer]": [186,[2,19,25]],
		"/(app)/products/[id=integer]/segments": [190,[2,19]],
		"/(app)/products/[id=integer]/statefeetables": [191,[2,19]],
		"/(app)/products/[id=integer]/statefeetables/edit/[statefeetableid=integer]": [192,[2,19]],
		"/(app)/products/[id=integer]/statefeetables/new": [193,[2,19]],
		"/(app)/products/[id=integer]/update": [194,[2,19]],
		"/(app)/products/[id=integer]/using-blueprint": [195,[2,19]],
		"/(app)/products/[id=integer]/webhooks": [196,[2,19,26]],
		"/(app)/products/[id=integer]/webhooks/new": [199,[2,19,26]],
		"/(app)/products/[id=integer]/webhooks/[subscriptionId=integer]/deliveries": [197,[2,19,26]],
		"/(app)/products/[id=integer]/webhooks/[subscriptionId=integer]/edit": [198,[2,19,26]],
		"/(auth)/register": [219,[27]],
		"/(auth)/resetpassword": [220,[27]],
		"/(app)/sandbox": [200,[2]],
		"/(app)/search": [201,[2]],
		"/(app)/statements": [202,[2]],
		"/(app)/tasks": [203,[2]],
		"/(app)/tasks/approvals": [205,[2]],
		"/(app)/tasks/[id=integer]": [204,[2]],
		"/(open)/terms": [236,[32]],
		"/(app)/truebi": [206,[2]],
		"/(app)/user/activities": [207,[2]],
		"/(app)/user/edit": [208,[2]],
		"/(app)/utilities": [209,[2]],
		"/(app)/utilities/batch-checks": [210,[2]],
		"/(app)/utilities/batch-checks/[id=integer]": [211,[2]],
		"/(app)/utilities/postal-code-timezones": [212,[2]],
		"/(customer)/view-statements": [234,[29]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);